module.exports = __webpack_public_path__ + "img/673.785add31.jpg";